import React from 'react'
import { AssetMap, Round } from "../types"

interface HelpModalProps {
  round: Round,
  assets: AssetMap,
  dismiss()
}

export default function HelpModal({ round, assets, dismiss }: HelpModalProps) {
  return (
    <div id="round-help-modal" className="modal modal--bottom-sheet-mobile show">
      <div className="modal-wrapper">
        <div className="modal-header">
          <div className="modal-header-inner">
            <div className="modal-title">Help</div>
            <a onClick={dismiss} className="modal-dismiss">
              <img src={assets.close} alt="Close" />
            </a>
          </div>
        </div>
        <div className="modal-main">
          <div className="container">
            <p style={{ padding: "1rem 0" }}>
              Thanks for playing Spark Golf!
              Please contact us below with any questions.
              We're here to help 9am - 9pm ET Monday - Friday.
            </p>
            <p style={{ padding: "1rem 0" }}>
              <strong>Text/Voicemail</strong>
              <br />
              <a href={`sms:${round.helpNumber.number}`}>{round.helpNumber.text}</a>
            </p>
            <p style={{ padding: "1rem 0" }}>
              <strong>Email</strong>
              <br />
              <a href="mailto:help@spark.golf">help@spark.golf</a>
            </p>
          </div>
        </div>
      </div>
      <div className="modal-mask" onClick={dismiss} />
    </div>
  )
}
